// Central content for the Dive Master landing page (pt-BR).
// TEMPORARY generic/stock imagery (to be replaced with real brand assets later).

export const CONTACT = {
  brand: "DIVE MASTER",
  whatsappDisplay: "(47) 9968-6547",
  whatsappLink: "https://wa.me/5547999686547?text=Ol%C3%A1%2C%20tenho%20algumas%20d%C3%BAvidas%20com%20rela%C3%A7%C3%A3o%20a%20promo%C3%A7%C3%A3o%202%20mergulhos%20pelo%20pre%C3%A7o%20de%20um.",
  whatsappFloatLink: "https://wa.me/5547999686547?text=Ol%C3%A1%2C%20tenho%20algumas%20d%C3%BAvidas%20com%20rela%C3%A7%C3%A3o%20a%20promo%C3%A7%C3%A3o%202%20mergulhos%20pelo%20pre%C3%A7o%20de%20um.",
  instagram: "https://instagram.com/mergulhobc",
  instagramHandle: "@mergulhobc — Dive Master",
  address: "Rua José Alexandre Rocha, 63 — Bairro Perequê, Porto Belo, SC",
  cnpj: "50.990.553/0001-07",
  years: 11,
};

// Vertical Reels video (9:16). Leave empty to show the "reserved space" placeholder.
export const REELS_VIDEO = "/video/promo2x1.mp4";
export const REELS_POSTER = "/images/promo2x1-cover.jpg";

// Full-screen HERO background video (autoplay, muted, loop). Leave empty for the
// ocean + bubbles gradient background. Set to the video URL when available.
export const HERO_VIDEO = "/video/hero.mp4";

// Real brand assets (logo + official photos).
export const IMG = {
  logo: "/images/real_logo.png",
  heroTurtle: "/images/turtle-real.jpg",       // diver + green sea turtle (HQ)
  couple: "/images/couple-hands-real.webp",    // couple holding hands + instructor (HQ)
  crab: "/images/real_c.webp",                 // diver thumbs up + crab
  starfish: "/images/real_b.jpg",              // diver + starfish
  octopus: "/images/octopus-real.png",         // octopus close-up
  coupleKiss: "/images/real_a.webp",           // couple face to face
  gurnard: "/images/gurnard.png",              // flying gurnard (peixe-voador)
  angelfish: "/images/angelfish.png",          // French angelfish (peixe-frade)
  turtleDiver2: "/images/turtle-diver2.png",   // diver + turtle (vertical)

  coupleReef: "/images/couple-hands-real.webp", // used by Imagine section
  boat: "/images/boat-real.png",               // REAL boat: Caravela Ana Clara
  turtle: "/images/turtle-real.jpg",
};

export const HERO_SEQUENCE = [
  IMG.heroTurtle,
  IMG.couple,
  IMG.crab,
  IMG.starfish,
];

export const HERO_BADGES = [
  "Não precisa saber nadar",
  "Um instrutor por pessoa",
  "Fotos subaquáticas",
  "Equipamentos inclusos",
  "Voucher válido por 1 ano",
  "+500 avaliações no Google",
];

export const MARQUEE_ITEMS = [
  "Aventura", "Tartarugas", "Cardumes", "Raios de luz",
  "Costa Esmeralda", "Adrenalina", "Bolhas subindo", "Sinal de OK",
];

export const TIMELINE = [
  { n: 1, title: "Você embarca", text: "Recepção calorosa e embarque seco, sem correria." },
  { n: 2, title: "Navega pela Costa Esmeralda", text: "As águas mais bonitas de Porto Belo e Bombinhas." },
  { n: 3, title: "Toma café a bordo", text: "Um café da manhã servido enquanto você visualiza lindas paisagens." },
  { n: 4, title: "Recebe todas as instruções", text: "Seu instrutor prepara você com calma e segurança." },
  { n: 5, title: "Entra na água acompanhado", text: "Um instrutor exclusivo do início ao fim, só para você." },
  { n: 6, title: "Respira debaixo d'água", text: "O momento que muda tudo. A primeira respiração." },
  { n: 7, title: "Conhece a vida marinha", text: "Tartarugas, peixes, polvos e todo um mundo escondido." },
  { n: 8, title: "Recebe suas fotos", text: "Registros para guardar essa aventura para sempre." },
];

export const COMPARE_NOW = [
  "Menor preço do ano",
  "Voucher válido por 1 ano",
  "Pode usar no verão",
  "Pode escolher a data depois",
];
export const COMPARE_WAIT = [
  "Valor cheio",
  "Menor disponibilidade",
  "Maior procura",
  "Promoção encerrada",
];

export const BOAT_FEATURES = [
  "Embarque seco",
  "Café servido a bordo",
  "Conforto e espaço",
  "Vista panorâmica",
  "Área para relaxar",
  "Poucas pessoas por saída",
];

export const GALLERY = [
  { src: IMG.turtleDiver2, tall: true, cap: "Nade ao lado de tartarugas marinhas" },
  { src: IMG.couple, tall: false, cap: "Um momento inesquecível a dois" },
  { src: IMG.octopus, tall: true, cap: "Encontros surpreendentes com polvos" },
  { src: IMG.gurnard, tall: false, cap: "Peixe-voador exibindo suas cores" },
  { src: IMG.crab, tall: false, cap: "Vida marinha ao alcance das mãos" },
  { src: IMG.angelfish, tall: false, cap: "Peixe-frade entre os recifes" },
  { src: IMG.coupleKiss, tall: false, cap: "Liberdade absoluta debaixo d'água" },
  { src: IMG.starfish, tall: false, cap: "Estrelas-do-mar e recifes cheios de vida" },
  { src: IMG.turtle, tall: false, cap: "Tartarugas por todo o percurso" },
];

export const REVIEWS = [
  { name: "Ligia Pauli", city: "Balneário Camboriú, SC", initials: "LP", color: "#14307D", quote: "Foi maravilhosa a experiência! Nunca havia mergulhado e me apaixonei. Já estou marcando pra voltar com minha família — meus filhos precisam viver isso!" },
  { name: "Evelin Lima", city: "Blumenau, SC", initials: "EL", color: "#ED2E24", quote: "Fiquei completamente segura e confortável debaixo d'água. Gostei tanto que já decidi: vou fazer o curso completo com eles pra virar mergulhadora certificada." },
  { name: "Marina Freitag", city: "Curitiba, PR", initials: "MF", color: "#1E56C0", quote: "O instrutor Lucas foi incrível! Super paciente, explicou tudo com calma. Nos sentimos seguros do começo ao fim. Recomendo pra qualquer pessoa que tem medo de mergulhar." },
  { name: "Rafael Souza", city: "Joinville, SC", initials: "RS", color: "#14307D", quote: "A Ananda cuidou de cada detalhe — desde o briefing até as fotos. É notável o amor que a equipe tem pelo que faz. Melhor passeio das nossas férias, sem dúvida!" },
  { name: "Camila Duarte", city: "Florianópolis, SC", initials: "CD", color: "#ED2E24", quote: "Excelente do começo ao fim! O atendimento no WhatsApp já é impecável, sempre respondem rápido e tiram todas as dúvidas. No dia do passeio a experiência é ainda melhor do que prometem." },
];

export const STATS = [
  { value: "+30 mil", label: "mergulhos realizados" },
  { value: "+500", label: "avaliações no Google" },
  { value: "+11 anos", label: "realizando sonhos" },
];

export const INCLUSIONS = [
  { icon: "Ship", label: "Passeio de barco" },
  { icon: "Timer", label: "40 minutos de mergulho com cilindro" },
  { icon: "UserCheck", label: "Instrutor exclusivo" },
  { icon: "Waves", label: "Flutuação com neoprene antes e depois do mergulho" },
  { icon: "PackageCheck", label: "Equipamentos completos" },
  { icon: "Shirt", label: "Roupa de neoprene" },
  { icon: "Glasses", label: "Máscara" },
  { icon: "Wind", label: "Snorkel" },
  { icon: "Footprints", label: "Nadadeiras" },
  { icon: "Camera", label: "10 fotos subaquáticas", brinde: true },
  { icon: "Coffee", label: "Café da manhã a bordo", brinde: true },
  { icon: "Cookie", label: "Lanches", brinde: true },
];

// Valor real da experiência no verão (pagando à parte), por pessoa.
export const SUMMER_PRICES = [
  { label: "Passeio de barco", price: "R$ 150" },
  { label: "Mergulho com cilindro", price: "R$ 250" },
  { label: "Fotos subaquáticas", price: "R$ 150" },
  { label: "Café a bordo", price: "R$ 30" },
  { label: "Flutuação com roupa de borracha + máscara e snorkel", price: "R$ 140" },
];
export const SUMMER_TOTAL = "R$ 720";
export const SUMMER_TOTAL_LABEL = "por pessoa no verão";

export const PRICE = {
  old: "R$ 1.160",
  now: "R$ 580",
  people: "para 2 pessoas",
  installments: "em até 10x de R$ 58 no cartão",
  secondLot: "R$ 680",
};

export const FAQS = [
  { q: "Onde fica a escola?", a: "Nossa escola fica na Rua José Alexandre Rocha, nº 63 — bairro Perequê, em Porto Belo (SC). Estacionamento fácil e a poucos minutos do centro." },
  { q: "Qual a duração do passeio?", a: "O passeio dura em média 4 horas. A saída acontece às 8h e o retorno está previsto para as 12h." },
  { q: "Crianças podem mergulhar?", a: "Sim! Crianças a partir de 8 anos já podem viver essa experiência com o batismo de mergulho, sempre acompanhadas por um instrutor certificado." },
  { q: "Preciso saber nadar para fazer o mergulho?", a: "Não! O batismo de mergulho foi feito exatamente para quem nunca mergulhou e não sabe nadar bem. O instrutor certificado fica com você o tempo todo, do briefing ao retorno." },
  { q: "E se no dia o tempo estiver ruim ou chovendo?", a: "Sua segurança vem primeiro. Se as condições climáticas não estiverem favoráveis, o reagendamento é totalmente gratuito e sem burocracia — você escolhe uma nova data que caiba na sua agenda." },
  { q: "O que está incluso no valor da promoção?", a: "Passeio de barco, equipamentos completos (roupa de neoprene, máscara, snorkel, nadadeiras, cilindro), instrutor exclusivo, 10 fotos subaquáticas (5 por pessoa), café a bordo e lanches — tudo incluso no preço promocional." },
  { q: "Como funciona a flexibilidade da promoção 2 por 1?", a: "Você compra hoje pagando por 1 e ganha 2 mergulhos. Pode usar em datas diferentes ao longo do ano, ou levar alguém especial junto no mesmo dia. O voucher vale por 1 ano — inclusive finais de semana, feriados e alta temporada." },
  { q: "Como faço para comprar meu ingresso?", a: "Como nossas vagas são limitadas, a compra é feita diretamente pelo WhatsApp com o próprio proprietário — assim garantimos disponibilidade e um atendimento personalizado. Você clica no botão de compra, é direcionado para o WhatsApp e conclui sua reserva em poucos minutos. Depois da confirmação, nossa equipe envia a agenda virtual para você escolher a melhor data." },
  { q: "A compra é segura?", a: "Sim, totalmente segura. Como as vendas são limitadas, o atendimento é feito diretamente com o proprietário pelo WhatsApp, garantindo transparência do início ao fim. Aceitamos PIX, cartão de crédito (parcelado em até 12x) e boleto." },
  { q: "Preciso ter experiência?", a: "Nenhuma experiência é necessária. Você recebe todas as instruções antes de entrar na água, com total segurança." },
  { q: "Quanto tempo dura a experiência?", a: "O passeio completo inclui a navegação, café a bordo, instruções e cerca de 40 minutos de mergulho acompanhado." },
  { q: "Por quanto tempo o voucher é válido?", a: "Seu voucher vale por 1 ano. Você pode escolher qualquer data — inclusive finais de semana, feriados e durante o verão." },
  { q: "Existe alguma restrição de saúde?", a: "Gestantes, pessoas com problemas cardíacos graves ou condições no ouvido devem consultar orientação médica. Fale com a gente pelo WhatsApp em caso de dúvida." },
];
